import { AddressRecord } from "common/records/Address";
import { IJobParamsData } from "common/records/index/JobParams";
import { IJobData } from "common/records/Job";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { Nullable } from "common/types";
import { List } from "immutable";

export const SET_CURRENT_JOB_ID = "@job/SET_CURRENT_JOB_ID";
export const FETCH_JOB = "@job/FETCH_JOB";
export const RECEIVE_JOB = "@job/RECEIVE_JOB";
export const RECEIVE_JOB_OVERVIEWS = "@job/RECEIVE_JOB_OVERVIEWS";
export const SET_JOB_LOADED = "@job/SET_JOB_LOADED";
export const SET_JOB_ERRORS = "@job/SET_JOB_ERRORS";
export const SET_SAMPLE_JOBS = "@job/SET_SAMPLE_JOBS";
export const RECEIVE_JOB_STATES = "@job/RECEIVE_JOB_STATES";
export const ADD_PHONE_NUMBER = "@job/ADD_PHONE_NUMBER";
export const REMOVE_PHONE_NUMBER = "@job/REMOVE_PHONE_NUMBER";
export const RESET_JOB = "@job/RESET_JOB";
export const TOGGLE_JOB_ARCHIVED = "@job/TOGGLE_JOB_ARCHIVED";
export const RECEIVE_JOB_PARAMS = "@job/RECEIVE_JOB_PARAMS";
export const RECEIVE_ORG_JOB_PARAMS = "@job/RECEIVE_ORG_JOB_PARAMS";
export const UPDATE_JOB_PARAMS = "@job/UPDATE_JOB_PARAMS";
export const RESET_JOB_PARAMS = "@job/RESET_JOB_PARAMS";
export const UPDATE_JOB_CREATE_FORM = "@job/UPDATE_JOB_CREATE_FORM";
export const SET_COVER_IMAGE = "@job/SET_COVER_IMAGE";
export const EDIT_RESOURCE_DISPLAY = "@job/EDIT_RESOURCE_DISPLAY";
export const SET_RESOURCE_DOCUMENTS = "@job/SET_RESOURCE_DOCUMENTS";
export const SET_JOB_ADDRESS = "@job/SET_JOB_ADDRESS";

export const JobActions = {
  setCurrentJobId: (id: Nullable<number>) => createAction(SET_CURRENT_JOB_ID, { id }),
  fetchJob: (id: number) => createAction(FETCH_JOB, { id }),
  receiveJob: (job: Partial<IJobData>) => createAction(RECEIVE_JOB, { job }),
  receiveJobOverviews: (jobs: IJobData[]) => createAction(RECEIVE_JOB_OVERVIEWS, { jobs }),
  setJobLoaded: (id: number) => createAction(SET_JOB_LOADED, { id }),
  setJobErrors: (id: number, errors: string[]) => createAction(SET_JOB_ERRORS, { id, errors }),
  setSampleJobs: (sampleJobs: string[]) => createAction(SET_SAMPLE_JOBS, { sampleJobs }),
  receiveJobStates: (jobStates: Record<string, { pretty_name: string; color: string }>) =>
    createAction(RECEIVE_JOB_STATES, { jobStates }),
  addPhoneNumber: () => createAction(ADD_PHONE_NUMBER),
  removePhoneNumber: (index: number) => createAction(REMOVE_PHONE_NUMBER, { index }),
  resetJob: () => createAction(RESET_JOB),
  toggleJobArchived: (jobId: number) => createAction(TOGGLE_JOB_ARCHIVED, { jobId }),
  receiveJobParams: (jobParams: IJobParamsData) => createAction(RECEIVE_JOB_PARAMS, { jobParams }),
  receiveOrgJobParams: (jobParams: IJobParamsData) => createAction(RECEIVE_ORG_JOB_PARAMS, { jobParams }),
  updateJobParams: (event: FormUpdateEvent) => createAction(UPDATE_JOB_PARAMS, { event }),
  resetJobParams: (jobParamsType: "jobParams" | "orgJobParams") => createAction(RESET_JOB_PARAMS, { jobParamsType }),
  update: (event: FormUpdateEvent) => createAction(UPDATE_JOB_CREATE_FORM, { event }),
  setCoverImage: (imageUuid: Nullable<string>) => createAction(SET_COVER_IMAGE, { imageUuid }),
  editResourceDisplay: (
    jobId: number,
    documentId: number,
    name: "displayInAgreement" | "displayInProposal",
    value: boolean,
  ) => createAction(EDIT_RESOURCE_DISPLAY, { jobId, documentId, name, value }),
  setResourceDocuments: (jobId: Nullable<number>, resourceDocuments: List<any>) =>
    createAction(SET_RESOURCE_DOCUMENTS, { jobId, resourceDocuments }),
  setJobAddress: (addressRecord: AddressRecord) => createAction(SET_JOB_ADDRESS, { addressRecord }),
};

export type JobActions = ActionsUnion<typeof JobActions>;
